import { render, staticRenderFns } from "./XtendDevicesWorldMap.vue?vue&type=template&id=5a15d6a5&"
import script from "./XtendDevicesWorldMap.vue?vue&type=script&lang=js&"
export * from "./XtendDevicesWorldMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports